@if (useMobileLayout$ | async) {
  <div class="tw:flex tw:h-full tw:w-full tw:flex-col">
    <div class="tw:relative tw:basis-3/5">
      <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
    </div>
    <div class="tw:basis-2/5 tw:overflow-y-scroll">
      <ng-template [ngTemplateOutlet]="sidebarTemplate"></ng-template>
    </div>
  </div>
} @else {
  <div class="tw:flex tw:h-full tw:w-full">
    <div class="md:tw:basis-5/12 xl:tw:basis-2/6 2xl:tw:basis-1/5 tw:basis-1/2 tw:overflow-y-scroll">
      <ng-template [ngTemplateOutlet]="sidebarTemplate"></ng-template>
    </div>
    <div class="md:tw:basis-7/12 xl:tw:basis-4/6 2xl:tw:basis-4/5 tw:relative tw:basis-1/2">
      <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
    </div>
  </div>
}

<ng-template #sidebarTemplate>
  <ng-content select="[sidebar]"></ng-content>
</ng-template>

<ng-template #contentTemplate>
  <ng-content select="[content]"></ng-content>
</ng-template>
